import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { fetchCasinoFinanceKpis } from "./casinoFinanceReportApi";

const queryKeyBase = ["casino", "financeKpis"];

/**
 * Aggregate KPIs for the date window + optional `subprovider` / `game`.
 *
 * Typical usage (two hook instances in Finance Reports):
 * - **Cascade metadata:** `subprovider` = draft selection, omit `game` — drives dropdown options.
 * - **KPI card totals:** `subprovider` + `game` = applied selections — aligns with the table.
 *
 * @param {{ start_date?: string; end_date?: string; subprovider?: string; game?: string; money_type?: string[] }} params
 */
export function useCasinoFinanceKpis(params, options = {}) {
  const { start_date, end_date, subprovider, game, money_type } = params;
  const moneyTypeKey = money_type?.join(",") ?? "";

  return useQuery({
    queryKey: [
      ...queryKeyBase,
      start_date,
      end_date,
      subprovider ?? null,
      game ?? null,
      moneyTypeKey,
    ],
    queryFn: () =>
      fetchCasinoFinanceKpis({
        start_date,
        end_date,
        subprovider,
        game,
        money_type,
      }),
    enabled: options.enabled !== false && Boolean(start_date && end_date),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });
}

